"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var phocus_1 = require("phocus");
var action_1 = require("../action/action");
var phocus_context_1 = require("../phocus-context/phocus-context");
var phocus_button_1 = require("../phocus-button/phocus-button");
phocus_1.ActionContextService.addContext("modal", {
    actions: {
        closeModal: new action_1.Action({
            name: "Close modal",
            shortDocumentation: "Closes the currently open modal",
            searchTerms: [],
            defaultKeys: ["Escape"],
            actOn: function (component) {
                component.props.close();
            }
        })
    }
});
var PhocusModal = /** @class */ (function (_super) {
    __extends(PhocusModal, _super);
    function PhocusModal(props) {
        var _this = _super.call(this, props) || this;
        _this.el = document.createElement("div");
        document.body.appendChild(_this.el);
        return _this;
    }
    PhocusModal.prototype.componentDidMount = function () {
        var _this = this;
        phocus_1.ConstrainFocusService.pushConstraint(function () { return _this.el; });
        Array.from(document.body.children).forEach(function (e) {
            if (e === _this.el)
                return;
            if (e.getAttribute("aria-hidden"))
                e.phocusOldAriaHidden = e.getAttribute("aria-hidden");
            e.setAttribute("aria-hidden", "true");
        });
    };
    PhocusModal.prototype.componentWillUnmount = function () {
        Array.from(document.body.children).forEach(function (e) {
            e.setAttribute("aria-hidden", e.dataset.phocusOldAriaHidden || "false");
        });
        phocus_1.ConstrainFocusService.popConstraint();
    };
    PhocusModal.prototype.render = function () {
        return ReactDOM.createPortal(React.createElement(phocus_context_1.PhocusContext, { context: "modal", argument: this, className: "phocus-modal--container" },
            this.props.children,
            React.createElement(phocus_button_1.PhocusButton, { action: "closeModal", className: "phocus-modal--background" },
                React.createElement("span", null))), this.el);
    };
    return PhocusModal;
}(React.Component));
exports.PhocusModal = PhocusModal;
//# sourceMappingURL=phocus-modal.js.map